
import { Component, Vue, Watch } from 'vue-property-decorator';
import VWrapper from '@/components/shared/VWrapper.vue';
import { namespace } from 'vuex-class';
import { Venue } from '@/interfaces/models/Venue';
import VEmptyState from '@/components/shared/VEmptyState.vue';
import DepositRuleTable from '@/components/depositRule/DepositRuleTable.vue';
import Filter from '@/interfaces/api/Filter';
import { DepositRule as DepositRuleModel } from '@/interfaces/models/DepositRule';

const venue = namespace('venue');
const depositRule = namespace('depositRule');

@Component({
  components: { DepositRuleTable, VEmptyState, VWrapper },
})
export default class DepositRule extends Vue {
  @venue.State('active') public venue!: Venue;

  @depositRule.Action('setFilter') public setFilter!: (filter: Filter) => void;
  @depositRule.Action('fetch') public getDepositRules!: any;
  @depositRule.Action('destroy') public deleteDepositRule!: (u: { id: string }) => {};
  @depositRule.State((state) => state.pagination.total) public total!: number;

  @depositRule.State('items') public items!: DepositRule[];

  public created() {
    if (!this.venue) {
      this.$startLoading('venue');
    }
  }

  public async mounted() {
    if (!this.venue) {
      this.$startLoading('venue');
    }
    if (this.venue) {
      this.$startLoading('depositRules');
      this.setFilter({ venue: this.venue._id });
      await this.getDepositRules({ page: 1 });
      this.$stopLoading('depositRules');
    }
  }

  public async destroy(depositRule: DepositRuleModel) {
    this.$startLoading('depositRules');
    await this.deleteDepositRule({ id: depositRule._id });
    this.$stopLoading('depositRules');
  }
  @Watch('venue')
  public onVenueChange() {
    if (this.venue && this.venue._id) {
      if (this.venue) {
        this.$startLoading('depositRules');
        this.setFilter({ venue: this.venue._id });
        this.getDepositRules({ page: 1 });
        this.$stopLoading('depositRules');
      }
    }
  }
}
